import React from 'react';
const rows = [{
  feature: '6 Tomos clínicos',
  a: true,
  b: true,
  c: true
}, {
  feature: '6 Bonos estratégicos',
  a: true,
  b: true,
  c: true
}, {
  feature: '30 planes + 100 recetas',
  a: true,
  b: true,
  c: true
}, {
  feature: 'Laboratorio y suplementación',
  a: false,
  b: true,
  c: true
}, {
  feature: 'Especialización y negocio',
  a: false,
  b: true,
  c: true
}, {
  feature: 'Materiales editables',
  a: false,
  b: false,
  c: true
}];
const Check = () => <span className="text-green-600 font-black" data-id="element-248">✓</span>;
const Dash = () => <span className="text-gray-300 font-black" data-id="element-249">—</span>;
export function ProBusiness() {
  return <section className="w-full px-4 sm:px-6 lg:px-8 py-10 text-gray-900" style={{
    backgroundImage: 'linear-gradient(180deg, rgb(236,253,245) 0%, rgb(236,253,245) 85%, rgb(255,255,255) 100%)',
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif'
  }} data-id="element-250">
      <div className="mx-auto max-w-2xl" data-id="element-251">

        {/* Header */}
        <h2 className="text-3xl font-black text-center text-gray-900 m-0 mb-2" data-id="element-252">
          ¿Qué incluye{' '}
          <span className="text-green-700" data-id="element-253">cada nivel?</span>
        </h2>
        <p className="text-center text-sm text-gray-500 m-0 mb-6" data-id="element-254">
          Todos arrancan con los 6 Tomos y 6 Bonos. Elegí hasta dónde querés llegar.
        </p>

        {/* Table */}
        <div className="overflow-x-auto rounded-xl border border-green-700/20 shadow-sm mb-6" data-id="element-255">
          <table className="w-full min-w-[420px] bg-white rounded-xl overflow-hidden text-xs" data-id="element-256">
            <thead data-id="element-257">
              <tr className="border-b border-gray-100" data-id="element-258">
                <th className="px-4 py-3 text-left font-bold text-gray-500 uppercase tracking-wide" data-id="element-259">
                  Incluye
                </th>
                <th className="px-4 py-3 text-center font-bold text-gray-500 border-l border-gray-100" data-id="element-260">
                  🥑 Megapack
                </th>
                <th className="px-4 py-3 text-center font-bold text-green-700 border-l border-gray-100 bg-green-50/50" data-id="element-261">
                  ⭐ Autoridad
                </th>
                <th className="px-4 py-3 text-center font-bold text-green-800 border-l border-gray-100 bg-green-100/50" data-id="element-262">
                  🏆 Completo
                </th>
              </tr>
            </thead>
            <tbody data-id="element-263">
              {rows.map((row, i) => <tr key={row.feature} className={i < rows.length - 1 ? 'border-b border-gray-100' : ''} data-id="element-264">
                  <td className="px-4 py-2.5 font-semibold text-gray-800" data-id="element-265">
                    {row.feature}
                  </td>
                  <td className="px-4 py-2.5 text-center border-l border-gray-100 bg-gray-50" data-id="element-266">
                    {row.a ? <Check data-id="element-267" /> : <Dash data-id="element-268" />}
                  </td>
                  <td className="px-4 py-2.5 text-center border-l border-gray-100 bg-green-50/50" data-id="element-269">
                    {row.b ? <Check data-id="element-270" /> : <Dash data-id="element-271" />}
                  </td>
                  <td className="px-4 py-2.5 text-center border-l border-gray-100 bg-green-100/50" data-id="element-272">
                    {row.c ? <Check data-id="element-273" /> : <Dash data-id="element-274" />}
                  </td>
                </tr>)}
              {/* Price row */}
              <tr className="border-t-2 border-green-700/20 bg-white" data-id="element-275">
                <td className="px-4 py-3 text-xs font-black text-gray-900 uppercase tracking-wide" data-id="element-276">
                  Precio
                </td>
                <td className="px-4 py-3 text-center border-l border-gray-100 font-black text-gray-900" data-id="element-277">
                  $24.990
                </td>
                <td className="px-4 py-3 text-center border-l border-gray-100 font-black text-green-700 bg-green-50/50" data-id="element-278">
                  $32.990
                </td>
                <td className="px-4 py-3 text-center border-l border-gray-100 font-black text-green-800 bg-green-100/50" data-id="element-279">
                  $39.990
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        {/* CTA */}
        <div className="text-center" data-id="element-280">
          <a href="#pricing" className="inline-block bg-green-700 text-white text-sm font-black rounded-xl px-8 py-3.5 no-underline shadow-lg hover:opacity-90 transition-opacity" data-id="element-281">
            🥑 → ELEGIR MI NIVEL AHORA
          </a>
          <p className="text-xs text-gray-400 font-medium mt-2 m-0" data-id="element-282">
            Garantía de 7 días · Acceso inmediato · 100% digital
          </p>
        </div>

      </div>
    </section>;
}